import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '../../utils/util';

@Injectable()
export class DistanceConversionProvider {
  convertMetersToMiles(meters: number, toFixed: number = null): number {
    const miles = meters / 1609.344;
    return isNullOrUndefined(toFixed) ? miles : parseFloat(miles.toFixed(toFixed));
  }
}
